// extracted by mini-css-extract-plugin
module.exports = {"root":"ContentLoader_root__1cYle","loader":"ContentLoader_loader__mSKCn","disabled":"ContentLoader_disabled__3qUbI"};